(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magcharm-about-03-values-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupSlider(slider) {
    if (!slider || slider.dataset.mcValuesReady === 'true') {
      return;
    }

    var track = slider.querySelector('[data-mc-values-track]');
    var prev = slider.querySelector('[data-mc-values-prev]');
    var next = slider.querySelector('[data-mc-values-next]');

    if (!track || !prev || !next) {
      return;
    }

    slider.dataset.mcValuesReady = 'true';

    function getStep() {
      var card = track.querySelector('.mc-value-card');

      if (!card) {
        return track.clientWidth;
      }

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: getStep() * -1, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initValuesSliders(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('[data-mc-values-slider]');

    sliders.forEach(function (slider) {
      setupSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initValuesSliders(document);
    });
  } else {
    initValuesSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initValuesSliders(event.target);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magcharm-about-06-design-principles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupSlider(slider) {
    if (!slider || slider.dataset.mcPrinciplesReady === 'true') {
      return;
    }

    var track = slider.querySelector('[data-mc-principles-track]');
    var prev = slider.querySelector('[data-mc-principles-prev]');
    var next = slider.querySelector('[data-mc-principles-next]');

    if (!track || !prev || !next) {
      return;
    }

    slider.dataset.mcPrinciplesReady = 'true';

    function getStep() {
      var card = track.querySelector('.mc-principle-card');

      if (!card) {
        return track.clientWidth;
      }

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: getStep() * -1, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initPrinciplesSliders(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('[data-mc-principles-slider]');

    sliders.forEach(function (slider) {
      setupSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPrinciplesSliders(document);
    });
  } else {
    initPrinciplesSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPrinciplesSliders(event.target);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magcharm-about-07-supergood-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupSlider(slider) {
    if (!slider || slider.dataset.mcSupergoodReady === 'true') {
      return;
    }

    var track = slider.querySelector('[data-mc-supergood-track]');
    var prev = slider.querySelector('[data-mc-supergood-prev]');
    var next = slider.querySelector('[data-mc-supergood-next]');

    if (!track || !prev || !next) {
      return;
    }

    slider.dataset.mcSupergoodReady = 'true';

    function getStep() {
      return track.clientWidth;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: getStep() * -1, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initSupergoodSliders(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('[data-mc-supergood-slider]');

    sliders.forEach(function (slider) {
      setupSlider(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSupergoodSliders(document);
    });
  } else {
    initSupergoodSliders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSupergoodSliders(event.target);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magcharm-featured-collection-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initFeaturedCollection = (root) => {
    if (!root || root.dataset.mcInitialized === 'true' || root.dataset.mode !== 'carousel') {
      return;
    }

    const track = root.querySelector('[data-mc-featured-track]');
    const cards = track ? Array.from(track.querySelectorAll('[data-mc-featured-card]')) : [];
    const previous = root.querySelector('[data-mc-featured-prev]');
    const next = root.querySelector('[data-mc-featured-next]');

    if (!track || !previous || !next || cards.length === 0) {
      return;
    }

    root.dataset.mcInitialized = 'true';
    let currentIndex = 0;

    const getVisibleCards = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      return Number(isDesktop ? root.dataset.desktopColumns : root.dataset.mobileColumns) || 1;
    };

    const update = () => {
      const visibleCards = getVisibleCards();
      const maxIndex = Math.max(0, cards.length - visibleCards);
      currentIndex = Math.min(currentIndex, maxIndex);

      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      track.style.transform = `translate3d(-${currentIndex * (cardWidth + gap)}px, 0, 0)`;

      const hasOverflow = maxIndex > 0;
      previous.hidden = !hasOverflow || currentIndex === 0;
      next.hidden = !hasOverflow || currentIndex === maxIndex;
    };

    previous.addEventListener('click', () => {
      currentIndex = Math.max(0, currentIndex - 1);
      update();
    });

    next.addEventListener('click', () => {
      const maxIndex = Math.max(0, cards.length - getVisibleCards());
      currentIndex = Math.min(maxIndex, currentIndex + 1);
      update();
    });

    window.addEventListener('resize', update);
    update();
  };

  const initAll = () => {
    document.querySelectorAll('[data-mc-featured-collection]').forEach(initFeaturedCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFeaturedCollection(event.target.querySelector('[data-mc-featured-collection]'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
